import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Common/Util/getMonthsByYear';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

export const useCompareValuesPerYearPerMonth = () => {
    const { chartData, filters, subtitlesSelectedYear } =
        useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = subtitlesSelectedYear.map((item, index) => {
        const data = months.map((month) => {
            const found = chartData.selectedYear.find(
                (counter) =>
                    parseInt(counter.mes_competencia, 10) ===
                    monthsIndexes[month]
            );

            return found
                ? Number(
                      index === 0
                          ? found.valor_complemento_federal
                          : found.valor_complemento_local
                  )
                : 0;
        });

        return {
            name: item,
            data
        };
    });

    return {
        series,
        subtitles: months
    };
};
